import measurementService from '../service/measurement';
import Vue from 'vue';
const state = {
    measurements: [],
    rawdataIndex: {
        minIndex: 0,
        minValue: 0,
        maxIndex: 0,
        maxValue: 0
    },
};
const getters = {
    getMeasurementById: (state) => (id) => {

        return state.measurements.find(x => x._id == id);
    }
};
const actions = {

    async getMeasurement({ getters, commit }, id) {
        let data = getters.getMeasurementById(id);
        if (!data) {
            let m = await measurementService.getMeasurement(id);
            commit('setMeasurement', m);
            return m;
        } else {
            return data;
        }
    },
    async updateRawdataIndex({ commit }, indexs) {
        commit('setRawdataIndex', indexs);
    },
};

const mutations = {
    setMeasurement(state, measurement) {
        var index = state.measurements.findIndex(x => x._id == measurement._id);
        if (index != -1) {
            Vue.set(state.measurement, index, measurement);
        } else {
            state.measurements.push(measurement);
        }
    },
    setRawdataIndex(state, indexs) {
        state.rawdataIndex.minIndex = indexs.minIndex;
        state.rawdataIndex.maxIndex = indexs.maxIndex;
        state.rawdataIndex.minValue = indexs.minValue;
        state.rawdataIndex.maxValue = indexs.maxValue;
    },
};
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



